import { PinIcon } from "../Icons";

type Props = {
  id: number;
  is_pinned: number;
  handleUpdatePinned: (payload: {
    id: string | number;
    is_pin: number;
  }) => void;
};

export default function PinBtn({ id, is_pinned, handleUpdatePinned }: Props) {
  const handleClick = () => {
    if (is_pinned) {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    }
    handleUpdatePinned({ id, is_pin: is_pinned === 1 ? 0 : 1 });
  };

  return (
    <button
      className={`p-1 rounded-lg ${
        is_pinned ? "text-custom-blue-medium" : ""
      } hover:text-custom-blue-medium hover:scale-90 hover:bg-gray-100`}
      title="Pin sheet"
      onClick={handleClick}
    >
      <PinIcon fill={is_pinned ? "currentColor" : "white"} />
    </button>
  );
}
